<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M7.28033 13.0303C6.98744 13.3232 6.51256 13.3232 6.21967 13.0303L2.21967 9.03033C1.92678 8.73744 1.92678 8.26256 2.21967 7.96967L6.21967 3.96967C6.51256 3.67678 6.98744 3.67678 7.28033 3.96967C7.57322 4.26256 7.57322 4.73744 7.28033 5.03033L4.56066 7.75L13.25 7.75C13.6642 7.75 14 8.08579 14 8.5C14 8.91421 13.6642 9.25 13.25 9.25L4.56066 9.25L7.28033 11.9697C7.57322 12.2626 7.57322 12.7374 7.28033 13.0303Z"
    fill="currentColor"
  />
</svg>
